import React from 'react'
import DropdownComponent from './DropdownComponet'
import Sidebar from '../../components/sidebar/Sidebar'
import './settings.css'
const Settings = () => {
    return (
        <div className="settings-page">
            <Sidebar />

            <div className="settings-container">
                <div className="top">
                    <DropdownComponent />
                </div>
            </div> 

        </div>
    )
}

export default Settings